
import { useDetailTheme } from '../../DetailContext'
import './DetailAction.css'

const DetailAction = ({ children, onClick, color: customColor, disabled }: { children?: string, onClick: () => void, color?: string, disabled?: boolean }) => {
    const { color } = useDetailTheme()

    return (
        <div className="drawer-detail__action" style={{ color: customColor || color, opacity: disabled ? "0.5" : 1, pointerEvents: disabled ? "none" : "auto" }} onClick={onClick}>{children}</div>
    )
}

export default DetailAction
